export default __webpack_public_path__ + "static/media/walls-flooring.2ccf3d69.jpg";